define('views/shop/online/online_preview',[
    'views/_base/baseview',
    'text!views/shop/online/online_preview.html',
    'views/shop/online/merchant',
    'views/shop/instore/merchants_see_all_btn'
], function (BaseView, Template, MerchantView, SeeMerchantsBtnView) {
    'use strict';

    return BaseView.extend({
        id        : 'shop-online-ul-container',
        className : 'slider-inner-container',
        tagName   : 'div',
        isRender  : true,
        limit     : 10,
        counter   : 1,
        template  : _.template(Template),
        events    : {},
        initialize: function(options){
            options = options || {};

            this.merchants = options.collection;

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            this.merchants.forEach(this.addOne, this);

            return this;
        },

        addOne: function(merchant){
            
            if(this.counter < this.limit){

                var merchant = new MerchantView({ data: merchant });
                this.$el.find('#shop-online-list-container').append(merchant.el);

                this.counter++;

            } else if(this.counter == this.limit){
                
                var see_all_merchants_btn = new SeeMerchantsBtnView();
                this.$el.find('#shop-online-list-container').append(see_all_merchants_btn.el);
                this.$el.find('#shop-online-list-container').append('<li class="padding">&#160;</li>');
                this.counter++;
                
            }

        },

        close: function () {}
    });
});

